import * as Types from './planningActionTypes.js'

const initialState = {
    data: [],
    date: new Date()
};

export default function planning(state = initialState, action) {
    switch (action.type) {
        case Types.SET_PLANNINGDATA:
            if (state.data !== action.data) {
                return Object.assign({}, state, { data: action.data });
            }
            return state;
        case Types.SET_PLANNINGDATE:
            if (state.date !== action.date) {
                return Object.assign({}, state, { date: action.date });
            }
            return state;
        default:
            return state;
    }
}